import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useRestAPI } from "../useRestAPI";

export const GetMeQueryKey = "GetMeQuery";
export const useMeQuery = (queryOptions?: UseQueryOptions) => {
  const api = useRestAPI();

  return useQuery({
    ...queryOptions,
    queryFn: () => api.me.me(),
    queryKey: [GetMeQueryKey, queryOptions?.queryKey],
  });
};
